import { createAction, props } from '@ngrx/store';

export const loadQuoteCart = createAction('[Quote] Load Cart');

export const loadQuoteCartSuccess = createAction(
  '[Quote] Load Cart Success',
  props<{ data: any }>()
);

export const loadQuoteCartFail = createAction(
  '[Quote] Load Cart Fail',
  props<{ error: any }>()
);